import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Drawer, Layout, Menu} from "antd";

import SidebarContent from "./SidebarContent";
import {toggleCollapsedSideNav} from "../../appRedux/actions/Setting";
import { updateWindowWidth } from "../../appRedux/actions"
import {
    NAV_STYLE_DRAWER,
    NAV_STYLE_FIXED,
    NAV_STYLE_MINI_SIDEBAR,
    NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
    NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
    TAB_SIZE,
    THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import {UploadOutlined, UserOutlined, VideoCameraOutlined} from "@ant-design/icons";
import Helpers from "../../util/Helpers";
import {MAIN_MENU} from "../../constants/ServerUrl";

const {Sider} = Layout;

const Sidebar = (props) => {

    const dispatch = useDispatch();
    const {sidebarCollapsed} = props;
    const helper = new Helpers();
    const {themeType, navStyle} = useSelector(({settings}) => settings);
    const {navCollapsed} = useSelector(({common}) => common);
    const isMobile = useRef(false);
    const siderRef = useRef(null);
    const screenWidth = useSelector(({settings}) => settings.windowWidth);

    const onToggleCollapsedNav = () => {
        //  dispatch(toggleCollapsedSideNav(!navCollapsed));
    };

    // useEffect(() => {
    //     // setSidebarCollapsed(navStyle === NAV_STYLE_MINI_SIDEBAR)
    // }, [navStyle])

    useEffect(() => {
        // const handleResize = () => {
        //     dispatch(updateWindowWidth(window.innerWidth));
        // };

        // window.addEventListener('resize', handleResize);

        // return () => {
        //     window.removeEventListener('resize', handleResize);
        // }

    }, []);

    const handleMenuClick = () => {
        if (isMobile.current) {
            try {
                const siderElement =
                    document.querySelector(".ant-layout-sider");
                if (siderElement) {
                    const isCollapsed = siderElement.classList.contains(
                        "ant-layout-sider-collapsed"
                    );
                    siderElement.classList.toggle(
                        "ant-layout-sider-collapsed",
                        !isCollapsed
                    );

                    siderElement.style.flex = "0 0 0px";
                    siderElement.style.maxWidth = "0px";
                    siderElement.style.minWidth = "0px";
                    siderElement.style.width = "0px";

                    if (window.innerWidth < 768) {
                        try {
                            const header = document.querySelector(".ant-layout-header");
                            const content = document.querySelector(".ant-layout-content");
                            header.classList.toggle("w-full", isCollapsed);
                            content.classList.toggle("w-max", isCollapsed)
                        } catch (error) {
                            console.error("Error adjusting header", error);
                        }
                    }
                }
            } catch (error) {
                console.error("Error collapsing menu:", error);
            }
        }
    }

    const onTriggerClick = (collapsed) => {
        if (window.innerWidth < 768) {
            const siderElement =
                document.querySelector(".ant-layout-sider");
            const isCollapsed = siderElement.classList.contains("ant-layout-sider-collapsed");
            try {
                if (siderElement) {
                    const header = document.querySelector(".ant-layout-header");
                    const content = document.querySelector(".ant-layout-content");
                    if (!collapsed) {
                        header.classList.add("w-full");
                        content.classList.add("w-max");
                    }else if (collapsed || isCollapsed) {
                        header.classList.remove("w-full");
                        content.classList.remove("w-max");
                    }
                }
            } catch (error) {
                console.error("Error adjusting header", error);
            }
        }
    }


    return (
        <Sider
            breakpoint="lg"
            collapsible={true}
            collapsedWidth="0"
            width={"235"}
            className="h-screen bg-blue"
            onBreakpoint={broken => {
                isMobile.current = broken;
                console.log(broken);
            }}
            onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
                onTriggerClick(collapsed);
            }}
        >
            <div className="flex items-center justify-center py-3 bg-blue-50 bg-opacity-90 cursor-pointer"
                 onClick={() => {
                     window.location.href = MAIN_MENU;
                 }}>

                <img className="w-36" alt="Phillips Outsourcing Logo" src="/images/logo.png"/>
            </div>
            <SidebarContent onMenuClick={handleMenuClick}/>


        </Sider>
    )
};
export default Sidebar;
